<template>
  <div class="affair-container">
    <template v-if="viewType === 'list'">
      <search-box :status-list="statusList" ref="search" @change="research"></search-box>
      <div class="contentBox">
        <div class="contentTable">
          <el-table :data="tableData" size="medium">
            <el-table-column
                    prop="flowNo"
                    label="流程编号">
            </el-table-column>
            <el-table-column
                    prop="typeName"
                    label="类型">
            </el-table-column>
            <el-table-column
                    prop="applyUserName"
                    label="申请人">
            </el-table-column>
            <el-table-column
                    prop="description"
                    label="描述">
            </el-table-column>
            <el-table-column
                    prop="submitTime"
                    label="申请时间">
            </el-table-column>
            <el-table-column
                    prop="userList[0].name"
                    label="上节点提交人">
            </el-table-column>
            <el-table-column
                    prop="dealTime"
                    label="上节点提交时间">
            </el-table-column>
            <el-table-column
                    prop="status"
                    label="状态">
              <template slot-scope="scope" >
                <span class="status"  :class=[$reconava.getStatusClass(scope.row.status)]>
                  {{$reconava.getStatusName(scope.row.status)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createDate" width="200" label="操作">
              <template slot-scope="scope">
                <span @click="see(scope.row)" class="blue mgr10">查看</span>
                <!--     驳回状态的数据可以编辑     -->
                <span class="mgr10 blue" v-if="scope.row.status===3"  @click="edit(scope.row)">编辑</span>
                <!--     提交但是还没被审核的数据可以撤销        -->
                <span class="mgr10 blue" v-if="scope.row.status===102" @click="repeal(scope.row)">撤销</span>
                <!--     驳回的数据可以终止        -->
                <span class="mgr10 blue" v-if="scope.row.status===3" @click="terminate(scope.row)">终止</span>
              </template>
            </el-table-column>
          </el-table>
          <ReconovaPagination
                  v-if="tableData.length > 0"
                  @paginationChange="paginationChange"
                  :page-no="search.pageNum"
                  :page-size="search.pageSize"
                  :total="total"
          >
          </ReconovaPagination>

        </div>
      </div>
    </template>

    <template v-else-if="viewType === 'see'">
      <check-detail :id="currentId" @cancel="cancel" from="sponsor" type="see"></check-detail>
    </template>

    <template v-else-if="viewType === 'approvalDetail'">
      <approval-detail @changeType="close" type="initiation" :id="currentId"></approval-detail>
    </template>

    <template v-else-if="viewType === 'approvalEdit'">
      <approval-edit @changeType="close" viewStatus='edit' :initId="currentId + ''"></approval-edit>
    </template>

    <template v-else-if="viewType === 'flowDetail'">
      <flow-detail @changeType="close" type="initiation" :id="currentId"></flow-detail>
    </template>

    <template v-else-if="viewType === 'contractDetail'">
      <labor-contract-detail @changeType="close" :id="currentId"></labor-contract-detail>
    </template>

    <template v-else-if="viewType === 'contractEdit'">
      <labor-contract-edit @changeType="close" :id="currentId"></labor-contract-edit>
    </template>

    <template v-else-if="viewType === 'positiveDetail'">
      <positive-detail @changeType="close" :id="currentId"></positive-detail>
    </template>

    <template v-else-if="viewType === 'positiveEdit'">
      <positive-edit @changeType="close" :id="currentId"></positive-edit>
    </template>

    <template v-else-if="viewType === 'decorationEdit'">
      <check-add @cancel="close" :type-id="selectData.typeId" :edit-id="currentId"></check-add>
    </template>

    <template v-else-if="viewType === 'entryFlowEdit'">
      <entry-flow-edit :id="currentId" from="sponsor" @changeType="close"></entry-flow-edit>
    </template>

    <template
      v-else-if="['dynamicFormDetail', 'dynamicFormEdit'].includes(viewType)"
    >
      <dynamic-form-wrapper
        :id="currentId"
        :viewType="viewType"
        @changeType="close"
        :showHistory="true"
      ></dynamic-form-wrapper>
    </template>
  </div>
</template>

<script>
  import SearchBox from "./searchBox";
  import ReconovaPagination from "@/components/reconova/reconovaPagination";
  import SearchTabs from "./searchTabs";
  import CheckDetail from "../../businessModule/examine/formDetail/checkDetail";
  import mixins from "./components/mixins";
  import {processList} from "../../../services/checkModule";
  import LaborContractDetail from "../../businessModule/personnel/labor-contract/detail";
  import LaborContractEdit from "../../businessModule/personnel/labor-contract/edit";
  import PositiveDetail from "../../businessModule/personnel/positive/detail";
  import PositiveEdit from "../../businessModule/personnel/positive/edit";
  import {operatorDialog} from "../../../utils/utils";
  import CheckAdd from "../../businessModule/examine/formDetail/checkAdd";
  import entryFlowEdit from "@/pages/businessModule/personnel/entryFlow/add.vue";
  import approvalEdit from "@/pages/businessModule/personnel/employmentApplication/detail.vue"
  import DynamicFormWrapper from "./components/dynamicFormWrapper.vue";
  export default {
    name: "initiation",
    components: {
      CheckAdd,
      PositiveEdit,
      PositiveDetail,
      entryFlowEdit,
      LaborContractEdit, 
      LaborContractDetail, 
      CheckDetail, 
      SearchTabs, 
      ReconovaPagination, 
      SearchBox,
      approvalEdit,
      DynamicFormWrapper,
    },
    mixins: [ mixins ],
    data() {
      return {
        currentId:'',//当前详情id
        viewType:'list',
        statusList:([{label:'全部',value:''}]).concat(this.$map.getter('aiosAuditStatus')),
        search:{pageNum:1,pageSize:20},
        tableData:[],
        total:0,
        selectData:null
      }
    },
    methods: {
      cancel(){
        this.viewType = 'list'
      },

      research(){
        this.search.pageNum = 1;
        this.getData()
      },
      //获取列表数据
      getData(){
        let search = Object.assign(this.search,this.$refs.search.getQuery());
        search.keyList = (search.keyList && search.keyList.join && search.keyList.join(',')) || '';
        processList(search).then(res => {
          this.tableData = res.data.list.map(item => {
          return {
            ...item,
            description: item.content ? item.content.description : '',
          }
        });
          this.total = res.data.total
        })
      },

      //翻页
      paginationChange(type, val) {
        if (type === "pageNo") {
          this.search.pageNum = val;
        } else {
          this.search.pageNum = 1;
          this.search.pageSize = val;
        }
        this.getData()
      },

      // 撤销
      repeal(data){
        operatorDialog(
          this,
          "理由",
          "撤销",
          (value) => {
            let param = {
              id: data.id,
              typeId: data.typeId,
              reason: value || "",
            };
            this.$api.checkapi.repealMyApply(param).then((response) => {
              this.$message.success("已撤销");
              this.getData();
            });
          },
          {
            placeholder:
              data.typeId == 9
                ? data.businessInfo.content.advanced.approveOpinion.cancel.msg
                : "",
            required:
              data.typeId == 9 &&
              data.businessInfo.content.advanced.approveOpinion.cancel.required,
          }
        );
      },

      // 终止
      terminate(data){
        operatorDialog(this,'理由','终止',(value)=>{
          let param = {
            id:data.id,
            typeId:data.typeId,
            reason:value||''
          }
          this.$api.checkapi.terminateMyApply(param).then(response=>{
            this.$message.success('已终止');
            this.getData()
          })
        }, {
            placeholder:
              data.typeId == 9
                ? data.businessInfo.content.advanced.approveOpinion.cancel.msg
                : "",
            required:
              data.typeId == 9 &&
              data.businessInfo.content.advanced.approveOpinion.cancel.required,
          })
      }
    },
    mounted() {
      this.getData()
    }
  }
</script>

<style scoped>
@import "css/examine.scss";
</style>
